<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'doctrine.country.information'|translate">
      <form class="" #countryForm="ngForm" action="javascript:">
        <div class="form-row row">
          <div class="form-group col-md-3">
            <label for="name">{{"doctrine.country.name" | translate}}<span class="star">*</span></label>
            <input required name="name"
                   #countryName="ngModel"
                   id="name"
                   class="form-control"
                   [(ngModel)]="country.name">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="countryName.invalid && countryName.dirty && countryName.errors?.required">{{'errors.required'|translate}}
            </div>
          </div>
        </div>
        <div>
          <strong>{{"doctrine.country.vat" | translate}}</strong>
        </div>
        <hr/>
        <div class="form-row row">
          <div class="form-group col-md-3">
            <label for="dealer-vat">{{"doctrine.country.dealer_vat" | translate}} (%)<span class="star">*</span></label>
            <div class="input-group">
              <input required name="dealer-vat" id="dealer-vat" [(ngModel)]="country.dealerVat" type="number"
                     #rate="ngModel" class="form-control" placeholder="%" min="0">
              <div class="messages text-danger"
                   *ngIf="rate.invalid && rate.dirty && rate.errors?.required">{{'errors.required'|translate}}
              </div>
            </div>
          </div>
          <div class="form-group col-md-3">
            <label for="customer-vat">{{"doctrine.country.customer_vat" | translate}} (%)<span class="star">*</span></label>
            <div class="input-group">
              <input required name="customer-vat" id="customer-vat" [(ngModel)]="country.customerVat" type="number"
                     #rate="ngModel" class="form-control" placeholder="%" min="0">
              <div class="messages text-danger"
                   *ngIf="rate.invalid && rate.dirty && rate.errors?.required">{{'errors.required'|translate}}
              </div>
            </div>
          </div>
        </div>
        <div>
          <strong>{{"doctrine.country.formats" | translate}}</strong>
        </div>
        <hr/>
        <div class="form-row row">
          <div class="form-group col-md-3">
            <label for="date-format">{{"doctrine.country.date_format" | translate}}<span class="star">*</span></label>
            <ng-select required name="dateFormat" id="date-format" [items]="dateFormatOptions"
                       [(ngModel)]="country.dateFormat" [clearable]="false"></ng-select>
          </div>
          <div class="form-group col-md-3">
            <label for="currency-format">{{"doctrine.country.currency_format" | translate}}<span
              class="star">*</span></label>
            <ng-select required name="currencyFormat" id="currency-format" [items]="currencyFormatOptions"
                       [(ngModel)]="country.currencyFormat" [clearable]="false"></ng-select>
          </div>
          <div class="form-group col-md-3">
            <label for="currency-decimals">{{"doctrine.country.currency_decimals" | translate}}<span
              class="star">*</span></label>
            <ng-select required name="currencyDecimals" id="currency-decimals" [(ngModel)]="country.currencyDecimals"
                       [items]="currencyDecimalsOptions" [clearable]="false"></ng-select>
          </div>
        </div>
        <div class="text-end">
          <button (click)="backToList()" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button type="button" class="btn btn-primary ripple light" [disabled]="!countryForm.valid"
                  (click)="saveCountry()">{{(isEdit ? 'global.save_changes' : 'global.add')|translate}}</button>
        </div>
      </form>
    </app-card>
  </div>
</div>
